<template>
  <div class="box has-padding-300 has-text-centered content">
    <h3 class="is-size-3">Application unavailable.</h3>
    <p>
      Unfortunately this application is not available from the hostname
      <strong>{{ hostname }}</strong
      >.
    </p>
  </div>
</template>

<script>
export default {
  name: "InvalidTenantModal",
  computed: {
    hostname() {
      return window.location.hostname;
    }
  }
};
</script>
